export default __webpack_public_path__ + "static/media/foresight.9dc452fb.svg";